import {
  FormDataPost,
  Get,
  getAPIUrl,
  Post,
} from "../../ApiServices/apiMethod";

export const WalletEdnpoint = {
  profile: "user/profile",
  addWithReq: "user/add-withdraw-request",
  addFundReq: "user/add-fund-request",
  getWithdrawalReq: "user/withdraw-requests",
  getFundReq: "user/fund-requests",
  /////////////////////////////////////////////////////////////////////////
  //   updateProfile: "user/update-profile",
  //
  //
  //   // walletBalance: "user/wallet-balance",
  //   fetchReferHistory: "user/fetch-refer-history",
  //   walletTxns: "user/wallet-transactions",
  //   settings: "user/setting",
  //   fetchTeamDetail: "user/fetch-team-details",
  //   userComission: "user/fetch-user-commission",

  //   paymetApi: "user/payment-upi",
  //   paymentStatus: "user/paymentStatus",
};

export const getProfile = (param = "") => {
  const url = getAPIUrl(WalletEdnpoint.profile, param);
  return Get(url);
};
export const AddWithdrawalReq = (data, param = "") => {
  const url = getAPIUrl(WalletEdnpoint.addWithReq, param);
  return FormDataPost(url, data);
};

export const AddFundReq = (data, param = "") => {
  const url = getAPIUrl(WalletEdnpoint.addFundReq, param);
  return FormDataPost(url, data);
};
export const getWithdrawalReq = (param = "") => {
  const url = getAPIUrl(WalletEdnpoint.getWithdrawalReq, param);
  return Get(url);
};
export const getFundReq = (param = "") => {
  const url = getAPIUrl(WalletEdnpoint.getFundReq, param);
  return Get(url);
};
///////////////////////////////////////////////////////////////////
// export const getWallletBalance = (param = "") => {
//   const url = getAPIUrl(UserEndPoints.walletBalance, param);
//   return Get(url);
// // };
// export const updateProfile = (data, param = "") => {
//   const url = getAPIUrl(UserEndPoints.updateProfile, param);
//   return FormDataPost(url, data);
// };

// export const getReferHistory = (param = "") => {
//   const url = getAPIUrl(UserEndPoints.fetchReferHistory, param);
//   return Get(url);
// };

// export const getWalletTxns = (param = "") => {
//   const url = getAPIUrl(UserEndPoints.walletTxns, param);
//   return Get(url);
// };

// export const getWalletSettings = (param = "") => {
//   const url = getAPIUrl(UserEndPoints.settings, param);
//   return Get(url);
// };

// export const getTeamDetail = (param = "") => {
//   const url = getAPIUrl(UserEndPoints.fetchTeamDetail, param);
//   return Get(url);
// };

// export const getUserComission = (param = "") => {
//   const url = getAPIUrl(UserEndPoints.userComission, param);
//   return Get(url);
// };

// export const createPaymentApi = (data, param = "") => {
//   const url = getAPIUrl(UserEndPoints.paymetApi, param);
//   return Post(url, data);
// };

// export const checkPaymentstatus = (data, param = "") => {
//   const url = getAPIUrl(UserEndPoints.paymentStatus, param);
//   return Post(url, data);
// };
